import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'

import { Auth } from 'aws-amplify'

import { Input } from 'antd'
import { Button } from 'antd'
import { Progress } from 'antd'
import { message } from 'antd'
import { Row } from 'antd'
import { Col } from 'antd'
import Tooltip from '@material-ui/core/Tooltip'

import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { MailOutlined } from '@ant-design/icons'
import { LockOutlined } from '@ant-design/icons'
import {
  updateAuthData,
  LOGED_IN,
  LOGED_OUT,
  CHANGE_PASSWORD_CHALLENGE,
  EMAIL_VERIFICATION_CHALLENGE,
} from 'store/auth/auth'
import tychoLogo from 'assets/tycho-logo.png'

const Password = Input.Password

function EmailChallenge() {
  const [verificationCode, setVerificationCode] = useState('')

  const authData = useSelector((state) => state.auth.authData)

  const dispatch = useDispatch()

  const verificationSuccess = () => {
    dispatch(
      updateAuthData({
        ...authData,
        emailVerified: true,
        authStatus: LOGED_IN,
      }),
    )
  }

  const submitVerificationCode = () => {
    const verificacionCode = verificationCode
    Auth.verifyCurrentUserAttributeSubmit('email', verificacionCode)
      .then(verificationSuccess)
      .catch((err) => {
        // eslint-disable-next-line
        console.log(err)
      })
  }

  const reseendVerificationCode = () => {
    Auth.verifyCurrentUserAttribute('email').then(() => {
      message.success('El código se ha mandado al correo ' + authData.email)
    })
  }

  return (
    <div
      style={{
        backgroundColor: '#1a2022',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ width: '300px', position: 'absolute', top: '35%' }}>
        <img
          src={tychoLogo}
          style={{
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'block',
            width: '300px',
            height: 'auto',
          }}
        />

        <div style={{ textAlign: 'center', maginTop: '20px' }}>
          <h1 style={{ color: 'white', fontSize: '16px' }}>Enter your verification code</h1>
        </div>
        <div style={{ marginTop: '30px' }}>
          <Input disabled={true} prefix={<MailOutlined />} placeholder="Email" value={authData.email} />
        </div>

        <div style={{ marginTop: '10px', display: 'flex', position: 'relative' }}>
          <Password
            onChange={(event) => {
              setVerificationCode(event.target.value)
            }}
            placeholder="Verification code"
            value={verificationCode}
            onPressEnter={submitVerificationCode}
          />
          <Tooltip
            title="Fill this entry with the verification code that was sent to your email"
            placement="right"
            arrow
          >
            <HelpOutlineIcon className="cp-help-icon" />
          </Tooltip>
        </div>

        <div style={{ marginTop: '20px', float: 'right', width: '100%', display: 'flex', position: 'relative' }}>
          <Button type="primary" onClick={reseendVerificationCode} style={{ float: 'right', width: '100%' }}>
            Resend Code
          </Button>
          <Tooltip title="If you don't get a verification code, click here" placement="right" arrow>
            <HelpOutlineIcon className="cp-help-icon" />
          </Tooltip>
        </div>

        <div style={{ marginTop: '10px', float: 'right', width: '100%' }}>
          <Button type="primary" onClick={submitVerificationCode} style={{ float: 'right', width: '100%' }}>
            Confirm
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EmailChallenge
